import { ChartSeries } from './index';

export class BarChartSeries extends ChartSeries {
    public constructor(props, options) {
        super(props, options);
    }
}
